module.exports = __webpack_public_path__ + "static/media/slide6.9d102143.png";